export const SORT_DIRECTION_ASC = "ASC";
export const SORT_DIRECTION_DESC = "DESC";

